import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingCart from "@/components/FloatingCart";
import ProtectedRoute from "@/components/ProtectedRoute";
import ScrollToTop from "@/components/ScrollToTop";
import Tracker from "@/components/Tracker";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ProductDetail from "@/pages/ProductDetail";
import Offers from "@/pages/Offers";
import OfferDetail from "@/pages/OfferDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Account from "@/pages/Account";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminOffers from "@/pages/admin/AdminOffers";
import AdminGallery from "@/pages/admin/AdminGallery";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminDocument from "@/pages/admin/AdminDocument";

function PublicLayout({ children }) {
  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <FloatingCart />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Tracker />
            <Toaster position="top-right" richColors />
            <Routes>
              <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
              <Route path="/produse" element={<PublicLayout><Catalog /></PublicLayout>} />
              <Route path="/produs/:slug" element={<PublicLayout><ProductDetail /></PublicLayout>} />
              <Route path="/oferte" element={<PublicLayout><Offers /></PublicLayout>} />
              <Route path="/oferta/:id" element={<PublicLayout><OfferDetail /></PublicLayout>} />
              <Route path="/cos" element={<PublicLayout><Cart /></PublicLayout>} />
              <Route path="/finalizare" element={<PublicLayout><Checkout /></PublicLayout>} />
              <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
              <Route path="/autentificare" element={<PublicLayout><Login /></PublicLayout>} />
              <Route path="/inregistrare" element={<PublicLayout><Register /></PublicLayout>} />
              <Route
                path="/contul-meu"
                element={
                  <ProtectedRoute>
                    <PublicLayout><Account /></PublicLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute adminOnly>
                    <AdminLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<AdminDashboard />} />
                <Route path="produse" element={<AdminProducts />} />
                <Route path="oferte" element={<AdminOffers />} />
                <Route path="galerie" element={<AdminGallery />} />
                <Route path="comenzi" element={<AdminOrders />} />
              </Route>
              <Route
                path="/admin/document/:type/:id"
                element={
                  <ProtectedRoute adminOnly>
                    <AdminDocument />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
